var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-avatar',{staticClass:"id-info-modal__avatar",attrs:{"image":_vm.imageUrl,"is-loading":_vm.loading,"aspect-ratio":0,"crop-title":"Upload image"},on:{"save":_vm.uploadDocumentPhoto}})}
var staticRenderFns = []

export { render, staticRenderFns }